// extracted by mini-css-extract-plugin
module.exports = {"itemImage":"Item_itemImage__1Mu9d","itemName":"Item_itemName__MP1df","itemContainer":"Item_itemContainer__Y71Jp"};